import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the tableInformeGerencialView.
 * @extends JetView
 */
export default class tableInformeGerencialView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const id_partner = this.getParam('partner', true); // Retrieve partner ID from parameters

        /**
         * Formats a percentage value.
         * @param {number} value - The value to format.
         * @returns {string} The formatted percentage string.
         */
        function percentFormat(value) {
            return webix.i18n.numberFormat(value) + '%'; // Format value as percentage
        }

        // Extend the summTreeColumn filter to customize the refresh behavior
        webix.ui.datafilter.summTreeColumn = webix.extend(
            {
                /**
                 * Refreshes the summary tree column.
                 * @param {Object} master - The master view.
                 * @param {Object} node - The node to refresh.
                 * @param {Object} value - The value object containing columnId.
                 */
                refresh: function (master, node, value) {
                    var result = 0; // Initialize result for summation
                    var resultFormat = 0; // Initialize formatted result
                    master.data.each(function (obj) {
                        if (obj.$level == 1) result += obj[value.columnId]; // Sum values at level 1
                    });
                    // Format the result based on the columnId
                    if (value.columnId === 'CantidadTickets') {
                        resultFormat = webix.i18n.numberFormat(result);
                    } else {
                        if (value.columnId === 'GgrPorc') {
                            resultFormat = webix.i18n.numberFormat(result) + '%';
                        } else {
                            resultFormat = webix.i18n.priceFormat(result);
                        }
                    }
                    node.firstChild.innerHTML = resultFormat; // Update the node with formatted result
                },
            },
            webix.ui.datafilter.summColumn, // Extend from the existing summColumn filter
        );

        return {
            rows: [
                {
                    id: 'preloader', // ID for the preloader
                    cols: [
                        {
                            view: 'treetable', // Define a treetable view
                            id: 'treetable', // ID for the treetable
                            css: 'webix_header_border webix_data_border webix_footer_border informeGerencial', // CSS classes for styling
                            scheme: {
                                $group: {
                                    /**
                                     * Grouping function for the treetable.
                                     * @param {Object} obj - The data object to group.
                                     * @returns {string} The HTML string for the group header.
                                     */
                                    by: function (obj) {
                                        return "<i class='flags " + obj.CountryIcon + "'></i>" + obj.Pais; // Group by country icon and name
                                    },
                                    css: 'bold', // CSS class for group header
                                    map: {
                                        CantidadTickets: ['CantidadTickets', 'sum'], // Mapping for summation
                                        CantidadTicketsCasino: ['CantidadTicketsCasino', 'sum'],
                                        CantidadTicketsCasinoVivo: ['CantidadTicketsCasinoVivo', 'sum'],
                                        TotalTickets: ['TotalTickets', 'sum'],
                                        AmountDeposits: ['AmountDeposits', 'sum'],
                                        AmountWinnings: ['AmountWinnings', 'sum'],
                                        Deposits: ['Deposits', 'sum'],
                                        WithdrawPending: ['WithdrawPending', 'sum'],
                                        Paid: ['Paid', 'sum'],
                                        Stake: ['Stake', 'sum'],
                                        StakeCasino: ['StakeCasino', 'sum'],
                                        StakeLiveCasino: ['StakeLiveCasino', 'sum'],
                                        TotalStake: ['TotalStake', 'sum'],
                                        Payout: ['Payout', 'sum'],
                                        PayoutCasino: ['PayoutCasino', 'sum'],
                                        PayoutLiveCasino: ['PayoutLiveCasino', 'sum'],
                                        TotalPayout: ['TotalPayout', 'sum'],
                                    },
                                },
                            },
                            bready: function () {
                                this.openAll(); // Expand all rows when ready
                            },
                            scrollY: screen.width < 820 ? false : true, // Enable vertical scrolling based on screen width
                            height: screen.width < 820 ? 450 : 0, // Set height based on screen width
                            columns: [
                                {
                                    id: 'Fecha', // Column ID for date
                                    header: _('Fecha'), // Column header with localization
                                    width: 170, // Column width
                                    template: function (obj, common) {
                                        if (obj.$group) return common.treetable(obj, common) + obj.value; // Return group header if it's a group
                                        return obj.Fecha; // Return date value
                                    },
                                },
                                {
                                    id: 'Moneda', // Column ID for currency
                                    header: _('Moneda'), // Column header with localization
                                    width: 70, // Column width
                                },
                                {
                                    id: 'CantidadTickets', // Column ID for ticket count
                                    header: _('Cantidad Tickets'), // Column header with localization
                                    format: webix.i18n.intFormat, // Format as integer
                                    width: 120, // Column width
                                },
                                {
                                    id: 'CantidadTicketsCasino', // Column ID for casino ticket count
                                    header: _('Cant Tickets Casino'), // Column header with localization
                                    format: webix.i18n.intFormat, // Format as integer
                                    width: 120, // Column width
                                },
                                {
                                    id: 'CantidadTicketsCasinoVivo', // Column ID for live casino ticket count
                                    header: _('Cant Tickets Casino Vivo'), // Column header with localization
                                    format: webix.i18n.intFormat, // Format as integer
                                    width: 120, // Column width
                                },
                                {
                                    id: 'TotalTickets', // Column ID for total tickets
                                    header: _('Total Tickets'), // Column header with localization
                                    format: webix.i18n.intFormat, // Format as integer
                                    width: 120, // Column width
                                },
                                {
                                    id: 'AmountDeposits', // Column ID for deposit amount
                                    header: _('Saldo Recargas'), // Column header with localization
                                    format: webix.i18n.numberFormat, // Format as number
                                    width: 130, // Column width
                                },
                                {
                                    id: 'AmountWinnings', // Column ID for winnings amount
                                    header: _('Saldo Disp Retiro'), // Column header with localization
                                    format: webix.i18n.numberFormat, // Format as number
                                    width: 130, // Column width
                                },
                                {
                                    id: 'Deposits', // Column ID for deposits
                                    header: _('Valor Recargas'), // Column header with localization
                                    format: webix.i18n.numberFormat, // Format as number
                                    width: 130, // Column width
                                },
                                {
                                    id: 'WithdrawPending', // Column ID for pending withdrawals
                                    header: _('Nota de retiro pendiente'), // Column header with localization
                                    format: webix.i18n.numberFormat, // Format as number
                                    width: 130, // Column width
                                },
                                {
                                    id: 'Paid', // Column ID for paid amount
                                    header: _('Valor Pagado'), // Column header with localization
                                    format: webix.i18n.numberFormat, // Format as number
                                    width: 130, // Column width
                                },
                                {
                                    id: 'Stake', // Column ID for stake amount
                                    header: _('Valor Apostado'), // Column header with localization
                                    format: webix.i18n.numberFormat, // Format as number
                                    width: 130, // Column width
                                },
                                {
                                    id: 'StakeCasino', // Column ID for casino stake amount
                                    header: _('Vlr Ap. Casino'), // Column header with localization
                                    format: webix.i18n.numberFormat, // Format as number
                                    width: 150, // Column width
                                },
                                {
                                    id: 'StakeLiveCasino', // Column ID for live casino stake amount
                                    header: _('Vlr Ap. Casino Vivo'), // Column header with localization
                                    format: webix.i18n.numberFormat, // Format as number
                                    width: 170, // Column width
                                },
                                {
                                    id: 'TotalStake', // Column ID for total stake
                                    header: _('Total Apostado'), // Column header with localization
                                    format: webix.i18n.numberFormat, // Format as number
                                    width: 130, // Column width
                                },
                                {
                                    id: 'Payout', // Column ID for payout amount
                                    header: _('Valor premios'), // Column header with localization
                                    format: webix.i18n.numberFormat, // Format as number
                                    width: 130, // Column width
                                },
                                {
                                    id: 'PayoutCasino', // Column ID for casino payout amount
                                    header: _('Vlr Pr. Casino'), // Column header with localization
                                    format: webix.i18n.numberFormat, // Format as number
                                    width: 130, // Column width
                                },
                                {
                                    id: 'PayoutLiveCasino', // Column ID for live casino payout amount
                                    header: _('Vlr Pr. Casino Vivo'), // Column header with localization
                                    format: webix.i18n.numberFormat, // Format as number
                                    width: 130, // Column width
                                },
                                {
                                    id: 'TotalPayout', // Column ID for total payout
                                    header: _('Total premios'), // Column header with localization
                                    format: webix.i18n.numberFormat, // Format as number
                                    width: 130, // Column width
                                },
                            ],
                            ready: function () {
                                if (!this.count()) {
                                    webix.extend(this, webix.OverlayBox); // Extend with overlay box functionality
                                    this.showOverlay(
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') + // Show overlay if no data
                                            '</div>',
                                    );
                                }
                            },
                            autowidth: false, // Disable automatic width adjustment
                            math: true, // Enable mathematical operations
                            datafetch: 10, // Number of data items to fetch
                            pager: 'pagerA', // ID for the pager
                            leftSplit: 2, // Number of columns to split on the left
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid component to initialize.
     */
    init(grid) {
        const id_partner = this.getParam('partner', true); // Retrieve partner ID from parameters
        grid = $$('treetable'); // Get the treetable instance
        var url =
            devConfig.geturlApi() + // Construct the API URL
            'es/Financial/GetUsuarioOnlineResumido?Partner=' +
            id_partner +
            '&';

        // Event listener for filtering data based on user input
        this.on(this.app, 'usuarioOnlineResumido:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize query string
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to query string
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to query string
                    } else {
                        if (object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filter parameters
                        } else {
                            if (object[i][0] == 'Date') {
                                var date = object[i][1].replace(' 00:00:00', ''); // Clean up date string
                                string1 = string1 + '&dateFrom=' + date; // Add dateFrom to query string
                                string1 = string1 + '&dateTo=' + date; // Add dateTo to query string
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Create date object for start
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to query string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Create date object for end
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add dateTo to query string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&Partner=' + id_partner; // Append partner ID to query string
            grid.clearAll(); // Clear existing grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data into grid
        });

        // Event listener for item click to trigger user ID event
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get the clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Call user ID event with item ID
        });

        // Event listener for player selection to load data based on player ID
        this.on(this.app, 'player:select', (Id) => {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Load data for selected player
            );
        });
    }
}

// FILE DOCUMENTED
